import React, { useEffect, useState } from 'react'
import './index.scss'
import { connect } from 'react-redux'
import { landTrustDetailsMenuBarHide } from '../../../../action/land-trust-menu-bar'
import closeIcon from '../../../../../asset/Close-X_Thin_F2F2F2_SVG.svg'
import { fetchPrivateLandGetListing, fetchPrivateLandsItemsAction, fetchPrivateLandItems } from '../../../../action/private-lands-action'
import logo from '../../../../../asset/smallandtrustlogo.png'
import Loader from '../../reusableComponents/loader/Loader'
import { landTrustRightMenuBarClose } from '../../../../action/land-trust-menu-bar'
import PropertiesDetails from './propertiesDetails'

const PrivateLandDetails = (props) => {
  const [landDetails, setLandDetails] = useState()
  const [loadSpinner, setLoadSpinner] = useState(true)
  const [isCarouselOpen, setIsCarouselOpen] = useState(false)
  const [currentIndex, setCurrentIndex] = useState(0)
  const [properties, setProperties] = useState([])
  const [selectProperties, setSelectProperties] = useState(null)

  useEffect(() => {
    if (!props?.itemDetails?.id) return;
    let payload = { listingId: props.itemDetails.id };
    props.fetchPrivateLandGetListing(payload, (res) => {
      let packages = JSON.parse(res.packages);
      setLandDetails(res);
      setProperties(packages);
      setLoadSpinner(false)
      props.fetchPrivateLandsItemsAction([res])
    });
  }, [props.itemDetails?.id]);

  const handleFilter = () => {
    setLoadSpinner(true)
    let payload = {
      stateName: props.selectedPrivateLandPayload.stateName,
    }

    props.fetchPrivateLandItems(payload)
      .then(() => setLoadSpinner(false))
      .catch(() => setLoadSpinner(false))
  }

  const closePrivateLandDetails = () => {
    props.landTrustDetailsMenuBarHide()
    props.landTrustRightMenuBarClose()
    handleFilter()
  }

  const selectProperty = (item) => {

    setSelectProperties(item)
  }

  let closeProperties = () => {
    setSelectProperties(null)
  }

  return (
    <div className='pt-side-Drawer-model-container'
      style={{
        height: 'calc(-130px + 100vh)',
        top: 'calc(128px + 0vh)',
        width: '46.86vw'
      }}
    >


      <div className='pt-land-details-container'>
        <div className='pt-header-container'>
          <div className='pt-header-img'>
            <img className='pt-close-icon' src={closeIcon} onClick={closePrivateLandDetails} alt="Close" />
          </div>
          <div className='pt-header'>
            <h1>{landDetails?.title}</h1>
            <p>{landDetails?.location}</p>
          </div>
          <div className='pt-logo-sort-container'>
            <img className='pt-logo' src={logo} alt="Logo" />
          </div>
        </div>

        {landDetails &&
          <div className='pt-land-info-container'>
            <div className='pt-image-container' style={{ width: '98%' }}>
              <div className='first-img-container'>
                <div style={{ width: '90%', height: '80%', borderRadius: '10px' }}>
                  <img
                    src={landDetails.imageUrls[0]}
                    alt="Land Preview"
                    className='image-bubble-hover'
                    style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block', cursor: 'pointer' }}
                    onClick={() => { setIsCarouselOpen(true); setCurrentIndex(0); }}
                  />
                </div>
              </div>

              <div className="second-img-container">
                <div className="list-img-container">
                  {landDetails.imageUrls.slice(1, 4).map((url, index) => (
                    <div
                      key={index}
                      className='list-img-style'
                      style={{
                      }}
                    >
                      <img
                        src={url}
                        alt={`Land Image ${index + 1}`}
                        className='image-bubble-hover'
                        style={{}}
                        onClick={() => { setIsCarouselOpen(true); setCurrentIndex(index + 1); }}
                      />
                    </div>
                  ))}

                  {landDetails.imageUrls.length > 4 && (
                    <div
                      className='show-more-img'
                      style={{
                        backgroundImage: `url(${landDetails.imageUrls[4]})`,
                      }}
                      onClick={() => { setIsCarouselOpen(true); setCurrentIndex(4); }}
                    >
                      +{landDetails.imageUrls.length - 4} more
                    </div>
                  )}
                </div>

              </div>
            </div>

            <div
              className='pt-land-details-description'
              dangerouslySetInnerHTML={{
                __html: landDetails.description.replace(/＜/g, "<").replace(/＞/g, ">"),
              }}
            />

            <p className='pt-book-now'
              style={{ height: 30 }}
            // onClick={() => window.open(props.PropertiesDetails.Link, '_blank')}
            >
              {/* Book Now */}
            </p>

            <div className='packages-list-container'
            //  style={{height:'45%'}}
            >
              {properties && properties.length > 0 && properties.map((item, index) => {
                return (
                  <div key={index} className='packages-list-item-container' onClick={() => selectProperty(item)}>

                    <div className='package-container'>
                      <img className='package-img' src={item.Images[0]}></img>
                      <p className='package-p' style={{}}>
                        {item.Title}
                      </p>
                    </div>
                  </div>
                )
              })}

            </div>

          </div>}
      </div>

      {/* Carousel Modal */}
      {isCarouselOpen && (
        <div className="carousel-overlay" onClick={() => setIsCarouselOpen(false)}>
          <div className="carousel-content" onClick={(e) => e.stopPropagation()}>
            <p onClick={() => setIsCarouselOpen(false)} className="pt-close-btn">✕</p>
            <div className='carousel-navigation-pt'>
              <div className='carousel-navigation-pt-child'>
                {/* LEFT / PREVIOUS */}
                <div
                  className='pt-carousel-arrow'
                  onClick={() =>
                    setCurrentIndex((currentIndex - 1 + landDetails.imageUrls.length) % landDetails.imageUrls.length)
                  }
                >
                  ‹
                </div>

                {/* COUNTER */}
                <div>
                  <span className="carousel-counter">
                    {currentIndex + 1} / {landDetails.imageUrls.length}
                  </span>
                </div>

                {/* RIGHT / NEXT */}
                <div
                  className='pt-carousel-arrow'
                  onClick={() =>
                    setCurrentIndex((currentIndex + 1) % landDetails.imageUrls.length)
                  }
                >
                  ›
                </div>
              </div>
            </div>

            <img
              src={landDetails.imageUrls[currentIndex]}
              alt={`Carousel Image ${currentIndex + 1}`}
              className="carousel-img"
            />
          </div>
        </div>
      )}

      {selectProperties && <PropertiesDetails PropertiesDetails={selectProperties} landDetails={landDetails} closeProperties={closeProperties}></PropertiesDetails>}

      {loadSpinner && (
        <Loader position={'absolute'} left={'42%'} width={'30px'} />
      )}
    </div>
  )
}

const mapStateToProps = state => ({
  privateLandItems: state.privateLandItems,
  privateLandFilterValues: state.privateLandFilterValues,
  lantTrustPrivateLandDetails: state.lantTrustPrivateLandDetails,
  selectedPrivateLandPayload: state.selectedPrivateLandPayload
})

const mapDispatchToProps = dispatch => ({
  landTrustDetailsMenuBarHide: () => dispatch(landTrustDetailsMenuBarHide()),
  fetchPrivateLandGetListing: (payload, cb) => dispatch(fetchPrivateLandGetListing(payload, cb)),
  fetchPrivateLandsItemsAction: (payload) => dispatch(fetchPrivateLandsItemsAction(payload)),
  fetchPrivateLandItems: (payload) => dispatch(fetchPrivateLandItems(payload)),
  landTrustRightMenuBarClose: () => dispatch(landTrustRightMenuBarClose())
})

export default connect(mapStateToProps, mapDispatchToProps)(PrivateLandDetails)
